document.addEventListener("DOMContentLoaded", function() {
  const productGrid = document.querySelector('#product-grid');
  if (!productGrid) return;

  window.addEventListener('scroll', () => {
    const scrollHeight = document.documentElement.scrollHeight;
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const clientHeight = window.innerHeight;

    if (scrollTop + clientHeight >= scrollHeight - 400) {
      const nextButton = document.querySelector('a[rel="next"]');
      if (nextButton && !nextButton.classList.contains('loading')) {
        nextButton.classList.add('loading');
        fetch(nextButton.href)
          .then(response => response.text())
          .then(html => {
            const parser = new DOMParser();
            const newDoc = parser.parseFromString(html, 'text/html');
            const newItems = newDoc.querySelector('#product-grid').innerHTML;
            document.querySelector('#product-grid').insertAdjacentHTML('beforeend', newItems);
            
            const newPagination = newDoc.querySelector('.pagination-wrapper');
            const currentPagination = document.querySelector('.pagination-wrapper');
            if (newPagination && currentPagination) {
              currentPagination.innerHTML = newPagination.innerHTML;
            }
            nextButton.classList.remove('loading');
          });
      }
    }
  });
});